import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ItalicOutlinedSvg from "@ant-design/icons-svg/es/asn/ItalicOutlined";
import AntdIcon from "../components/AntdIcon";
var ItalicOutlined = function ItalicOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ItalicOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ItalicOutlined.displayName = 'ItalicOutlined';
}
export default /*#__PURE__*/React.forwardRef(ItalicOutlined);